// Admin UI utility functions

export const formatDate = (timestamp: any): string => {
  if (!timestamp) return 'N/A';
  
  try {
    if (timestamp.toDate) {
      return timestamp.toDate().toLocaleDateString();
    }
    return new Date(timestamp).toLocaleDateString();
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid Date';
  }
};

export const getUserRoleColor = (role: string): string => {
  switch (role.toLowerCase()) {
    case 'admin':
      return 'bg-purple-100 text-purple-800';
    case 'content_creator':
      return 'bg-blue-100 text-blue-800';
    case 'user':
      return 'bg-green-100 text-green-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getUserStatusColor = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'approved':
      return 'bg-green-100 text-green-800';
    case 'pending':
      return 'bg-yellow-100 text-yellow-800';
    case 'rejected':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const sortUsersByDate = <T extends { created_at: any }>(users: T[], order: 'asc' | 'desc' = 'desc'): T[] => {
  return [...users].sort((a, b) => {
    if (!a.created_at && !b.created_at) return 0;
    if (!a.created_at) return order === 'desc' ? 1 : -1;
    if (!b.created_at) return order === 'desc' ? -1 : 1;

    const aTime = a.created_at.seconds || new Date(a.created_at).getTime();
    const bTime = b.created_at.seconds || new Date(b.created_at).getTime();

    return order === 'desc' ? bTime - aTime : aTime - bTime;
  });
};
